import React from 'react';
import { Link } from 'react-router-dom';
import usePageMeta from '../hooks/usePageMeta';
import './NotFound.css';

/* Catch-all 404 page wired to <Route path="*" /> in App.js. Reuses
   the site's hero gradient + page-hero pattern so the lost-page
   screen still feels like part of Heaven Sent rather than a blank
   browser error. We also tell crawlers not to index this URL. */
function NotFound() {
  usePageMeta({
    title: 'Page Not Found',
    description: 'The page you were looking for could not be found. Head back to the Heaven Sent home page or browse our gallery.',
    path: '/404',
  });

  return (
    <main className="not-found">
      <div className="not-found-inner">
        <p className="section-label">404</p>
        <h1 className="script-font">Page not found</h1>
        <p className="not-found-sub">
          The page you were looking for doesn't exist or has moved.
          No worries — you can pick up where you left off below.
        </p>
        <div className="hero-buttons">
          <Link to="/" className="btn-pink btn-lg">Go Home</Link>
          <Link to="/quote" className="btn-ghost btn-lg">Request a Quote</Link>
        </div>
        <p className="not-found-help">
          Looking for something specific? <Link to="/contact">Get in touch</Link> and we'll point you in the right direction.
        </p>
      </div>
    </main>
  );
}

export default NotFound;
